import React, { Component } from 'react';

import Modal from 'react-awesome-modal';
import * as CookieService from '../CookieService';
import * as MMReceivingOrderAction from '../actions/MMReceivingOrderAction';
import MMReceivingOrderStore from '../stores/MMReceivingOrderStore';
import Autocomplete from 'react-autocomplete';
import Select from 'react-select';
import * as $ from 'jquery';
//import InputNumber from 'react-input-number';
import * as MenuAction from '../actions/MenuAction';
import SDIConstants from '../SDIConstants';
//import { MultiSelect } from 'multiselect-react-dropdown';
import MultiSelect from "react-multi-select-component";
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as LabelByLocationAction from '../actions/LabelByLocationAction';
import LabelByLocationStore from '../stores/LabelByLocationStore';
//import { DropdownMultiselectModule } from 'ng2-dropdown-multiselect';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { PODetail } from '../actions/OrderStatusAction';
import swal from 'sweetalert';
import PDFPreviewComponent from './PDFPreviewComponent';
import { withTranslation, Trans } from 'react-i18next'
import { color } from '@material-ui/system';
import ImageGallery from 'react-image-gallery';
import * as OrderStatusAction from '../actions/OrderStatusAction';
import OrderStatusStore from '../stores/OrderStatusStore';
let POsList = [];

let lineDetails = [];
let currentPagePath;
class MMReceivingOrderComponent extends Component {
    constructor(props) {
        super(props);
        this.ReceivingPageLoad = this.ReceivingPageLoad.bind(this);
        this.MMReceivingPODetail = this.MMReceivingPODetail.bind(this);
        this.GetPOAction = this.GetPOAction.bind(this);
        this.SumbitReceivingResponse = this.SumbitReceivingResponse.bind(this);
        this.SubmitReceive = this.SubmitReceive.bind(this);
        this.cancel = this.cancel.bind(this);
        this.DeliveryTicketResponse = this.DeliveryTicketResponse.bind(this);
        this.checkAndPrint = this.checkAndPrint.bind(this);
        this.printSelectedItemResonse = this.printSelectedItemResonse.bind(this);

        this.state = {
            ShiptoList: [],
            VendorList: [],
            POList: [],
            defaultShipto: [],
            defaultVendor: [],
            defaultPO: [],
            duration: "0",
            POID: "",

            PO_num: "",
            PODetailList: [],
            POTitleList: [],
            pageLoad: false,
            ShipviaList: [],
            POListItems: [],
            listDetail: [],
            listDetail: [],
            query: '',
            targetPO: "",
            labelCount: "",
            LabelCount: "",
            accordion: false,
            Response: [],
            ImageArray: [],
            ItemArray: [],
            ItemList: [],
            isFavorited: false,
            hide: false,
            isLoading: true,
            locArray: [],
            //'[09/27/22,INC0010146-Exception Handling], Priyanka D
            SubmitResponse: "",
            base64URL: "",
            accordionOpen: false,
            lessThan10: false,
            mixedQty: false,
            packQtyData: [],
            packQtyIndex: 0,
            submitPO: {},
            mismatchQty: false
        }
    }
    componentWillUnmount() {

        MMReceivingOrderStore.removeListener('ReceivingPageLoad', this.ReceivingPageLoad);
        MMReceivingOrderStore.removeListener('GetPODetails', this.MMReceivingPODetail);
        MMReceivingOrderStore.removeListener('SumbitReceiving', this.SumbitReceivingResponse);
        MMReceivingOrderStore.removeListener('DeliveryPDF', this.DeliveryTicketResponse);
        LabelByLocationStore.removeListener("PrintItem", this.printSelectedItemResonse);
        OrderStatusStore.removeListener("PassThroughAuthe", this.PassThroughAutheResponse);
    }
    componentDidMount() {
        
        $("#labelcount").hide();


        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        // $(`#${SDIConstants.SDILoader}`).addClass('hide'); 
        /*******NEW******wal-158******/
        const queryParams = new URLSearchParams(window.location.search)

        const orderno_noti = queryParams.get('ordno');
        //if (orderno_noti == "" || orderno_noti == null) {
        //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //}
        console.log("orderno_noti", orderno_noti)
        if (orderno_noti != "" && orderno_noti != null && orderno_noti != undefined) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            this.notificationorderno(orderno_noti);
        }
        /***********************END**********/

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let CribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        if (CribID == null || CribID == undefined || CribID == "" || CribID == " ") {
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        else {
            //Session_BUSUNIT = CookieService.getLocalStorageValues("Session_BUSUNIT");
            //currentPagePath = this.props.location.pathname;
            //currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
            $(`#duration${this.state.duration}`).prop("checked", true);

            //$(`#${SDIConstants.SDILoader}`).addClass('hide');

            let GetMMReceivingPageLoadBO = {
                POID: "",
                BU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                SHIPTO: "",
                DURATION: `${this.state.duration}`,
                VENDOR: "",
                CribID: CribID
            }

            /*DURATION: 6months send "0", 12months send "1", 2years send "2" */
            //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');

            //[02/09/24 WW-942 Add this displaying the panel as favorite - Nandhini L]
            currentPagePath = this.props.location.pathname;
            currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
            let getFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            };
            MMReceivingOrderAction.getCurrentFavPage(getFavPageBO);

            MMReceivingOrderAction.GetMMReceivingPageLoad(GetMMReceivingPageLoadBO);
        }

        //  $(`#${SDIConstants.SDILoader}`).addClass('hide');
        MMReceivingOrderStore.on('ReceivingPageLoad', this.ReceivingPageLoad.bind(this));
        MMReceivingOrderStore.on('GetPODetails', this.MMReceivingPODetail);

        MMReceivingOrderStore.on('SumbitReceiving', this.SumbitReceivingResponse);
        MMReceivingOrderStore.on('favpage', this.loadFavPageResponse.bind(this));
        MMReceivingOrderStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
       
        MMReceivingOrderStore.on('DeliveryPDF', this.DeliveryTicketResponse);
        LabelByLocationStore.on("PrintItem", this.printSelectedItemResonse);
        OrderStatusStore.on('PassThroughAuthe', this.PassThroughAutheResponse);
    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(MMReceivingOrderStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (MMReceivingOrderStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(MMReceivingOrderStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(MMReceivingOrderStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        //this.refreshMenu();
    };
    DeliveryTicketResponse = (event) => {

        //   OrderSuccessCOunt = OrderSuccessCOunt + 1
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let DeliveryPDF = MMReceivingOrderStore.DeliveryPdf;
        //if ((hidden == true || this.state.ShowPdf == true) && (this.state.base64URL != "" || OrderPdf != "")) {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $('#pdfPreview').modal('show');

        { }
        // }
        this.setState({ base64URL: DeliveryPDF })
        { this.ReceivingPageLoad() }




    }






    printSelectedItemResonse = (event) => {
        $("#labelcount").hide();
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let PrintResponse = LabelByLocationStore.printitem
        if (PrintResponse == "Fail" || PrintResponse == "Printer unavailable") {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $('#failpopup').modal('show');
        }
        else if (PrintResponse == "Success") {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $('#successprint').modal('show');
        }
        else {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $('#technicalIssue').modal('show');
        }
    }
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //[09/27/22, Bug - 2709 - To insert receive items panel as in fav page, Dhevanesam R]
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Receive Items",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            MMReceivingOrderAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            MMReceivingOrderAction.deleteFavPage(deleteFavPageBO)
        }
    };



    ReceivingPageLoad() {
        
        let PageLoadResponse = JSON.parse(MMReceivingOrderStore.PageLoadData);
        let vendorList = PageLoadResponse.ReceivePOVendTable;
        //let shiptoList = PageLoadResponse.ReceiveLocTable;
        //PC_WW_737_05  Pavithra R [6/2/2023 , SIT-1 Retesting bug 3651 fix WW-737 'PO is invalid' pop-up appears on Receive Items Page ]
        console.log("PageLoadReceive", PageLoadResponse);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        let vendorNameList = [];
        let POList = [];
        let shipList = [];

        if (vendorList.length > 0) {
            vendorList.map((item, index) => {
                let VND = {
                    value: item.VENDOR_ID,
                    label: item.SUPPLIERNAME

                };
                let PO = {
                    value: index,
                    label: item.PO_ID
                }

                vendorNameList.push(VND);

                POList.push(PO);
                let Shipto = {
                    value: item.SHIPTO_ID,
                    label: item.LOCNAME
                }
                shipList.push(Shipto);
            }

            )
            vendorNameList = vendorNameList.filter((v, i, a) => a.findIndex(t => (t.value.trim().toUpperCase() === v.value.trim().toUpperCase())) === i)
            shipList = shipList.filter((v, i, a) => a.findIndex(t => (t.value.trim().toUpperCase() === v.value.trim().toUpperCase())) === i)
            this.setState({
                VendorList: vendorNameList, POList: POList, ShiptoList: shipList,
                Response: PageLoadResponse, isLoading: false
            })
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "No PO found for the selected crib"
            });
        }
        //[02/09/24 WW-942 Commenting this out as it's causing a delay in displaying the panel as favorite - Nandhini L]
        {/* currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
         let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        MMReceivingOrderAction.getCurrentFavPage(getFavPageBO);
        */}
        //  $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    GetPOAction() {
        
        if (this.state.POID == "" && (this.state.defaultPO == "" || Object.keys(this.state.defaultPO).length == 0)) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please Select or Enter PO ID'
            });
            //   alert('Please Select or Enter PO ID');
            return;
        } else {
            this.setState({ PODetailList: [], pageLoad: true });
            let CribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");

            let PODetails = {
                POID: this.state.POID.length > 0 ? this.state.POID.trim() : this.state.defaultPO.label.trim(),
                BU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                SHIPTO: this.state.defaultShipto.value == "0" ? "" : this.state.defaultShipto.value,
                DURATION: this.state.duration,
                VENDOR: this.state.defaultVendor.value == "0" ? "" : this.state.defaultVendor.value,
                //(Receiving - capture images from SOLR search) - Deepthi
                UserId: CookieService.getLocalStorageValues("Session_UserID"),
                userBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                punchinSessionID: "",
                Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
                Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                Session_ACTIVEUSERS: CookieService.getLocalStorageValues("Session_ACTIVEUSERS"),
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                CurrentPage_Url: "/SDIXZEUS/receiving",
                Session_PARTLIST: CookieService.getLocalStorageValues("Session_PARTLIST"),
                Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_CARTFAIL: "N",
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                Location: CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
                CribID: CribID,
            };

            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            MMReceivingOrderAction.MMReceivingPODetail(PODetails);
            this.setState({ accordionOpen: false })
        }
    }
    MMReceivingPODetail() {
        let PageLoadResponse = JSON.parse(MMReceivingOrderStore.PODetailData);
        let DSPOTable = PageLoadResponse.DSPOtable;
        console.log("DSPOTable", DSPOTable);
        let POTable = PageLoadResponse.POTable;
        console.log("POTable", POTable);
        let shipviaTable = PageLoadResponse.shipviaTable;
        let ImgArray = [];
        let ImagData = PageLoadResponse.ImgTable;
        if (ImagData != undefined) {
            ImgArray = ImagData;
        }
        let expiredPO = [];

        DSPOTable.map((item, index) => {
            if (parseInt(item.HQTYPO) - parseInt(item.HQTYLNACCPT) == 0) {
                expiredPO.push(item);
            }
        })

        if (DSPOTable.length == expiredPO.length) {

        } else {
            let shipviaArr = [];
            shipviaTable.map((item, index) => {
                let Shipto = {
                    value: item.SHIP_TYPE_ID,
                    label: item.DESCRSHORT
                }
                shipviaArr.push(Shipto);
            })
            this.setState({
                PODetailList: DSPOTable,
                POTitleList: POTable,
                ShipviaList: shipviaArr,
                ImageArray: ImgArray
            })
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //'[09/27/22,INC0010146-Exception Handling], Priyanka D
    SumbitReceivingResponse = () => {
        

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        POsList.forEach((val, index) => {
            val.Entered_Label_Count = "1"
            val.Description = val.DESCR254_MIXED
            val.Item_ID = val.INV_ITEM_ID
            val.BinLocation = val.Bin_Location
            val.MFGId = val.MFG_ITM_ID
            val.barcodeid = val.barcodeid
            val.cribID = val.BUSINESS_UNIT_IN.substring(1)

        })
        let SubmitResponse = MMReceivingOrderStore.SumbitReceive;
        if (!SubmitResponse.toLowerCase().includes("error")) {
            this.setState({ POTitleList: [], PODetailList: [], listDetail: [], defaultVendor: [], defaultShipto: [], defaultPO: [], POID: "", POListItems: POsList })
        }
        this.setState({ SubmitResponse: SubmitResponse })
        $('#successpopup').modal('show');
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    deliveryTicket = () => {
        $('#successprint').modal('hide');
        $('#failPopup').modal('hide');
        $('#technicalIssue').modal('hide');
        let receiver_Id = this.state.SubmitResponse;
        if (receiver_Id.includes("Error")) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        else if (receiver_Id != "" && receiver_Id != undefined) {
            let DeliveryTicketBO = {
                User_BU: "WAL00",
                receiver_Id: receiver_Id
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');

            MMReceivingOrderAction.deliveryTicketPdf(DeliveryTicketBO);
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in generating Delivery Ticket"
            });
        }

    }
    SubmitReceive = () => {
        
        let POList = [];
        let packQtyData = [];
        POsList = this.state.PODetailList;
        POsList.forEach((value, index) => {
            value.Entered_Label_Count = "1";
        });

        //[11/8/2022]Adding additional BOs for submitting the receiving data so that it will be displayed in recvng report correctly - A1QA-155 - Poornima S

        this.state.PODetailList.map((item, index) => {
            // PC_RC_22 CPW-284 06/12/2024 s.sanjay
            if (this.state.PODetailList[index].PO_QTY != undefined && this.state.PODetailList[index].PO_QTY != "") {
                var parsedQty = parseFloat(item.PO_QTY);
                if (parsedQty != 0 && parsedQty != 0.0 && parsedQty != "" && parsedQty != undefined && parsedQty >= 0.5) {
                    let PODetails = {
                        PO_ID: this.state.PODetailList[index].PO_ID,
                        BUSINESS_UNIT_PO: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                        USER_ID: CookieService.getLocalStorageValues("Session_UserID"),
                        QTY_PO: this.state.PODetailList[index].PO_QTY,
                        BILL_OF_LADING: this.state.PODetailList[index].RECVTRACKNO,
                        Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                        ISA_RECV_EXCEPT: this.state.PODetailList[index].ISA_RECV_EXCEPT.trim(),
                        Vendor_ID: this.state.POTitleList[0].VENDOR_ID,
                        SHIPTO_ID: this.state.PODetailList[index].SHIPTO_ID,
                        ISA_ASN_SHIP_DT: this.state.PODetailList[index].ISA_ASN_SHIP_DT,
                        Descr254Mixed: this.state.PODetailList[index].DESCR254_MIXED,
                        MFG_ID: this.state.PODetailList[index].MFG_ID,
                        LINE_NBR: this.state.PODetailList[index].LINE_NBR,
                        SCHED_NBR: this.state.PODetailList[index].SCHED_NBR,
                        INV_ITEM_ID: this.state.PODetailList[index].INV_ITEM_ID,
                        INV_STOCK_TYPE: this.state.PODetailList[index].INV_STOCK_TYPE,
                        hQTYLNACCPT: this.state.PODetailList[index].HQTYLNACCPT,
                        hQtyPO: this.state.PODetailList[index].HQTYPO,
                        UNIT_OF_MEASURE: this.state.PODetailList[index].UNIT_OF_MEASURE,
                        TariffCode: this.state.PODetailList[index].ISA_TARIFF_CODE.trim(),
                        MFG_ITM_ID: this.state.PODetailList[index].MFG_ITM_ID,
                        PO_BU: this.state.PODetailList[index].PO_BU,
                        SITE_BU: this.state.PODetailList[index].PO_BU,
                        CURRENCY_CD: this.state.PODetailList[index].CURRENCY_CD,
                        SHIP_CURRENCY: this.state.PODetailList[index].SHIP_CURRENCY,
                        SHIP_BASE_CURRENCY: this.state.PODetailList[index].SHIP_BASE_CURRENCY,
                        DIST_CURRENCY: this.state.PODetailList[index].DIST_CURRENCY,
                        DIST_BASE_CURRENCY: this.state.PODetailList[index].DIST_BASE_CURRENCY,
                        REQ_ID: this.state.PODetailList[index].REQ_ID,
                        REQ_LINE_NBR: this.state.PODetailList[index].REQ_LINE_NBR,
                        RECEIVER_ID: this.state.PODetailList[index].RECEIVER_ID.trim(),
                        Ship_via: this.state.PODetailList[index].RECVSHIPVIA.value,
                        ISA_RECEIVING_CODE: this.state.PODetailList[index].ISA_RECEIVING_CODE.trim(),
                        ERS_ACTION: this.state.PODetailList[index].ERS_ACTION,
                        Receiving_Type: CookieService.getLocalStorageValues("Session_ReceivingType"),
                        RECV_LN_NBR: this.state.PODetailList[index].RECV_LN_NBR.trim(),
                        RecvBarCodePrint: CookieService.getLocalStorageValues("RecvBarCodePrint"),
                        HRCVDATE: this.state.PODetailList[index].HRCVDATE,
                        workOrder: this.state.PODetailList[index].ISA_WORK_ORDER_NO
                    };
                    POList.push(PODetails);

                    if (parsedQty < (item.HQTYPO - item.HQTYLNACCPT)) {
                        item.PACK_SLIP_QTY = 0;
                        packQtyData.push(item);
                    }

                }
            }

        })


        if (POList.length < 1) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please Enter Valid Quantity"

            });
            //  alert("Please Enter Quantity");
        }
        else {
            let PO = { "PoItemList": POList };
            if (packQtyData && packQtyData.length > 0) {
                this.setState({ submitPO: PO, packQtyIndex: 0, packQtyData: packQtyData });
                $('#packingSlipQtyPopup').modal('show');
            }
            else {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                MMReceivingOrderAction.SubmitReceiving(PO);
                this.setState({
                    accordionOpen: false,
                    PO_num: POList[0].PO_ID,
                    mismatchQty: false
                });
            }
        }
    }

    onChangePackingSlipQty = (e) => {
        let packQtyData = this.state.packQtyData;
        let packQtyIndex = this.state.packQtyIndex;
        let qtyRegex = SDIConstants.quantityRegEX;

        if (e.target.value) {
            if (qtyRegex.test(e.target.value)) {
                packQtyData[packQtyIndex].PACK_SLIP_QTY = e.target.value
            }
        }
        else {
            packQtyData[packQtyIndex].PACK_SLIP_QTY = e.target.value
        }

        this.setState({ packQtyData: packQtyData })
    }

    submitPackingSlip = () => {
        $('#packingSlipQtyPopup').modal('hide');
        let packQtyData = this.state.packQtyData;
        let mismatchQty = packQtyData.some(item => parseFloat(item.PO_QTY) !== parseFloat(item.PACK_SLIP_QTY));
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        MMReceivingOrderAction.SubmitReceiving(this.state.submitPO);
        this.setState({
            mismatchQty: mismatchQty,
            accordionOpen: false,
            PO_num: this.state.submitPO.PoItemList[0].PO_ID
        });
    }
    cancel = () => {
        let vendorList = this.state.Response.ReceivePOVendTable;
        //PC_WW_737_05  Pavithra R [6/2/2023 , SIT-1 Retesting bug 3651 fix WW-737 'PO is invalid' pop-up appears on Receive Items Page ]
        //   let shiptoList = this.state.Response.ReceiveLocTable;

        let vendorNameList = [];
        let POList = [];
        let shipList = [];



        vendorList.map((item, index) => {
            let VND = {
                value: item.VENDOR_ID,
                label: item.SUPPLIERNAME

            };
            let PO = {
                value: index,
                label: item.PO_ID
            }

            vendorNameList.push(VND);

            POList.push(PO);
            //PC_WW_737_05  Pavithra R [6/2/2023 , SIT-1 Retesting bug 3651 fix WW-737 'PO is invalid' pop-up appears on Receive Items Page ]
            let Shipto = {
                value: item.SHIPTO_ID,
                label: item.LOCNAME
            }
            shipList.push(Shipto);
        }



        )
        //PC_WW_737_05  Pavithra R [6/2/2023 , SIT-1 Retesting bug 3651 fix WW-737 'PO is invalid' pop-up appears on Receive Items Page ]
        vendorNameList = vendorNameList.filter((v, i, a) => a.findIndex(t => (t.value.trim().toUpperCase() === v.value.trim().toUpperCase())) === i)

        shipList = shipList.filter((v, i, a) => a.findIndex(t => (t.value.trim().toUpperCase() === v.value.trim().toUpperCase())) === i)
        this.setState({

            VendorList: vendorNameList,
            POList: POList, ShiptoList: shipList,
        })
        this.setState({ duration: "0" })
        this.setState({
            defaultPO: [], defaultShipto: [], defaultVendor: [], POID: "", PODetailList: [], pageLoad: false
        });
        $(`#duration${0}`).prop('checked', true);

        //this.setState({ defaultPO: [], defaultShipto: [], defaultVendor: [], POID: "", });
        //$("duration0").prop("checked", true);
    }

    handleChangeShipto = (values) => {
        //[11/28/22], Bug - 2906 - To clear vendor ID which is already selected, Dhevanesam R
        this.setState({ defaultPO: [], defaultVendor: [] });
        let vendor = [];
        let po = [];
        let POTable = this.state.Response.ReceivePOVendTable;
        let shiptoid = values.value;

        if (this.state.defaultVendor != undefined && this.state.defaultVendor.value != undefined) {
            POTable.filter((x) => x.SHIPTO_ID == shiptoid && x.VENDOR_ID == this.state.defaultVendor.value).map((item, index) => {
                let obj = {
                    value: index,
                    label: item.PO_ID
                }
                po.push(obj);
            })
            this.setState({ POList: po })
        } else {


            POTable.filter((x) => x.SHIPTO_ID == shiptoid).map((item, index) => {
                let obj = {
                    value: item.VENDOR_ID,
                    label: item.SUPPLIERNAME
                }
                vendor.push(obj);
            })
            //[10/17/22, Bug - 2728 - Receive items_ Vendor dropdown values are repeated, Dhevanesam R]
            vendor = vendor.filter((v, i, a) => a.findIndex(t => (t.value.trim().toUpperCase() === v.value.trim().toUpperCase())) === i)

            POTable.filter((x) => x.SHIPTO_ID == shiptoid).map((item, index) => {
                let obj = {
                    value: index,
                    label: item.PO_ID
                }
                po.push(obj);
            })
            this.setState({ VendorList: vendor, POList: po })
        }

        this.setState({
            defaultShipto: values,
            defaultVendor: [],
            defaultPO: [],
            POID: ""
        });


    }
    handleChangePO = (values) => {
        this.setState(
            { defaultPO: values, POID: "" })
    }
    handleChangeVendor = (values) => {
        
        this.setState({ defaultPO: [] });
        let vendorid = values.value;
        let shipto = [];
        let POTable = this.state.Response.ReceivePOVendTable;
        let po = [];
        let shiptolist = [];
        // let shiptoData = this.state.Response.ReceiveLocTable;

        //  if (this.state.defaultShipto != undefined && this.state.defaultShipto.value != undefined) {
        //     POTable.filter((x) => x.VENDOR_ID == vendorid && x.SHIPTO_ID == this.state.defaultShipto.value).map((item, index) => {
        //       let obj = {
        //            value: index,
        //           label: item.PO_ID
        //        }
        //       po.push(obj);
        //    })
        //  this.setState({ POList: po })
        //}
        //else {

        POTable.filter((x) => x.VENDOR_ID == vendorid).map((item, index) => {
            shipto.push(item.SHIPTO_ID);
        })

        //shiptoData.forEach(x => {
        //    if (shipto.some(y => y == x.CUSTID)) {
        //        let obj = {
        //            value: x.CUSTID,
        //            label: x.LOCNAME
        //        }
        //        shiptolist.push(obj);
        //    }
        //})
        POTable.filter((x) => x.VENDOR_ID == vendorid).map((item, index) => {
            let obj = {
                value: index,
                label: item.PO_ID
            }
            po.push(obj);
            //PC_WW_737_05  Pavithra R [6/2/2023 , SIT-1 Retesting bug 3651 fix WW-737 'PO is invalid' pop-up appears on Receive Items Page ]

            let Shipto = {
                value: item.SHIPTO_ID,
                label: item.LOCNAME
            }
            shiptolist.push(Shipto);
        })
        shiptolist = shiptolist.filter((v, i, a) => a.findIndex(t => (t.value.trim().toUpperCase() === v.value.trim().toUpperCase())) === i)
        this.setState({ ShiptoList: shiptolist, POList: po })
        //  }
        this.setState(
            { defaultVendor: values, POID: "", defaultPO: [] })
    }
    handleChangePOSearch = (values) => {

        this.setState(
            { POID: values.target.value})

    }
    handleChangePostID = (values) => {

        this.setState(
            { query: values.target.value })

    }
    handleChangeShipVia = (index, values) => {
        let PODetail = this.state.PODetailList;
        PODetail[index].RECVSHIPVIA = values;
        this.setState({ PODetailList: PODetail })
    }

    /*06/06/24,CPW-284,PC_RC_02], Sanjay S */
    checkAndPrint = () => {

        if (this.state.POListItems.length > 0) {
            let printItems = [];
            printItems = this.state.POListItems.filter(item =>
                item.PO_QTY != undefined &&
                item.PO_QTY != "" &&
                item.PO_QTY >= 0.5
            );
            this.state.listDetail.forEach(item => {
                item.Entered_Label_Count = 1;
            });
            this.setState({ listDetail: printItems })
            //let result = this.checkQuantity();

            // if (result.mixedQty) {
            $('#labelcount').modal('show');
            //}

            // else if (result.lessThan10) {
            //{ this.printLabels() }
            // }

        }

    }
    /*06/06/24,CPW-284,PC_RC_06], Sanjay S */
    /*checkQuantity = () => {
         let qtyLessThan10 = this.state.POListItems.filter(item => item.PO_QTY <= 10 && item.PO_QTY != undefined && item.PO_QTY != "").length;
         let qtygreaterThan10 = this.state.POListItems.filter(item => item.PO_QTY > 10);
         lineDetails = qtygreaterThan10;
         this.state.listDetail.forEach((value, index) => {
             value.Entered_Label_Count = "1";
         })
         this.setState({ listDetail: qtygreaterThan10 })
 
         return {
 
             mixedQty: qtyLessThan10 > 0 && qtygreaterThan10.length > 0 || qtygreaterThan10.length > 0,
             lessThan10: qtyLessThan10 > 0
 
         }
 
 
 
 
     }*/

    handleChangePOQTY = (index, values) => {
        let PODetail = this.state.PODetailList;
        let left = PODetail[index].HQTYPO - PODetail[index].HQTYLNACCPT;
        let parsedValue = parseFloat(values.target.value);

        const re = SDIConstants.quantityRegEX;

        if (!PODetail[index].hasOwnProperty('PO_QTY')) {
            PODetail[index].PO_QTY = "";
        }
        if (values.target.value == ".") {
            PODetail[index].PO_QTY = "";
        }

        if (values.target.value != "") {
            if (parsedValue <= left && re.test(values.target.value) && values.target.value !== "0.0") {
                PODetail[index].PO_QTY = values.target.value;
            }
        }
        else {
            PODetail[index].PO_QTY = values.target.value;
        }

        this.setState({ PODetailList: PODetail });
    }

    printLabels = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $("#labelcount").modal("hide");
        let locPoList = [];

        if (this.state.POListItems.length > 0) {
            this.state.POListItems.map((value, index) => {
                if (value.PO_QTY > 0.5 && value.PO_QTY != "" && value.PO_QTY != undefined) {
                    locPoList.push(value);

                }
            })

            locPoList.forEach((value, index) => {
                value.barcodeid = this.state.SubmitResponse
                /*06/06/24,CPW-284,PC_RC_07], Sanjay S */
                //value.LabelCount = value.PO_QTY <= 10 ? value.PO_QTY : value.Entered_Label_Count
                value.LabelCount = value.Entered_Label_Count
            });

            POsList = locPoList;

            if (this.state.mismatchQty) {
                let customFields = [{
                    customFieldName: "order_number",
                    customFieldValue: POsList[0].REQ_ID
                }]
                let PassAutheBO = {
                    UserID: CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                    UserBu: CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                    EmailID: CookieService.getLocalStorageValues("Session_EMAIL"),
                    IsThirdParty: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false,
                    PassWord: "",
                    OrderNumber: POsList[0].REQ_ID,
                    PONumber: POsList[0].PO_ID,
                    HomepageRequest: false,
                    customFields: customFields,
                    WorkOrder: POsList[0].ISA_WORK_ORDER_NO,
                    receivingPageRequest: true,
                    reason: "Missing Items",
                    isTruckCrib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT").toUpperCase() == "0W0T" ? true : false
                }
                OrderStatusAction.getPassThroughAutheURl(PassAutheBO)
            }

            let PrintItemBO = {
                ItemDetail: locPoList,
                LabelCount: "",
                Src: "REC",
                UserBU: CookieService.getLocalStorageValues("Session_BUSUNIT")
            };
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            LabelByLocationAction.printSelectedItem(PrintItemBO);

            

        }
    }
    PassThroughAutheResponse = () => {
        let URl = JSON.parse(OrderStatusStore.PassThroughAuthe)
        window.open(URl);
        window.preventDefault();
    }

    handleChangeTRACKNO = (index, values) => {
        let PODetail = this.state.PODetailList;

        const re = SDIConstants.quantityRegEX;

        if (!PODetail[index].hasOwnProperty('PO_QTY')) {
            PODetail[index].PO_QTY = "";
        }

        if (values.target.value != "") {
            if (re.test(values.target.value) && values.target.value !== "0.0") {
                PODetail[index].RECVTRACKNO = values.target.value.trim();
            }
        }
        else {
            PODetail[index].RECVTRACKNO = values.target.value.trim();
        }


        //this.setState({ PODetailList: PODetail });
        //Trimming Spaces from tracking number-Priyanka
        //PODetail[index].RECVTRACKNO = values.target.value.trim();

        this.setState({ PODetailList: PODetail })
    }

   
    handleChangeLabelCount = (index, e) => {
        let re = SDIConstants.quantityRegEX;
        let locPoList = this.state.POListItems;
        let listDetails = this.state.listDetail;
        let sameIndex = locPoList.findIndex(item => item.INV_ITEM_ID == listDetails[index].INV_ITEM_ID);
        let value = e.target.value
        if (value == "") {
            listDetails[index].Entered_Label_Count = "1";
            locPoList[sameIndex].Entered_Label_Count = "1";
        }

        else if (re.test(value)) {
            value = value.slice(0, 5);
            let maxLength = parseInt(value);

            if ((maxLength < 99999 || value == "") && maxLength != 0 && value != "-" && value != "e") {
                listDetails[index].Entered_Label_Count = value;
                locPoList[sameIndex].Entered_Label_Count = value;
            }
        }

        this.setState({ POListItems: locPoList, listDetail: listDetails })





    }


    handleChangeDURATION = (index, e) => {
        let CribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        
        $(`#duration${index}`).prop('check', 'checked');
        this.setState({ duration: index })
        let GetMMReceivingPageLoadBO = {
            POID: "",
            BU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            SHIPTO: "",
            DURATION: `${index}`,
            VENDOR: "",
            CribID: CribID
        }
        /*DURATION: 6months send "0", 12months send "1", 2years send "2" */

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        MMReceivingOrderAction.GetMMReceivingPageLoad(GetMMReceivingPageLoadBO);




    }

    search = () => {
        
        const BASE_URL = 'https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/place/textsearch/json?query=' + this.state.query + '&key=AIzaSyBck4pWT3uHaeUzqFGS9KwwT_QUAf2O0co';
        
        fetch(BASE_URL, {
            method: 'GET',
            headers: {

                'Access-Control-Allow-Credentials': true,
                'Access-Control-Allow-Headers': 'Content-type',
                "Content-type": "application/json; charset=UTF-8",
                'Access-Control-Allow-Methods': 'POST, GET'
            }
        })

            .then(json => console.log("NOCORS", json));
    }
    handleAccordion = () => {

        $('accordian-body').prop('aria-expanded', this.state.accordion);
        this.setState({ accordion: !this.state.accordion });
    }




    accordionClose = () => {
        this.setState({ accordionOpen: !this.state.accordionOpen })
    }


    POHeaderGrid = () => {
        return this.state.POTitleList.map((item, index) => {
            let PoDateTime = item.PO_DT;
            let Tindex = PoDateTime.indexOf("T");
            let PoDate = PoDateTime.substring(0, Tindex)
            return (
                <tr id={index}>

                    <td data-toggle="collapse" data-target="#order-row-1" className="accordion-toggle" onClick={() => this.accordionClose()}>
                        <span id="accordion" className={`accordion-arrow${this.state.accordionOpen ? ' accordion-arrow-change' : ''}`} onClick={() => this.accordionClose()}></span>
                    </td>
                    <td className="">{item.PO_ID}</td>
                    <td className="">{PoDate}</td>
                    <td className="">{item.SHIPTO_ID}</td>
                    <td className="">{item.VENDOR_ID}</td>
                    <td className="">{item.VendorName}</td>
                    <td className="">{item.ADDRESS1}<br /> {item.ADDRESS2}, {item.CITY}, {item.STATE}, {item.POSTAL} </td>
                </tr>


            )
        })
    }
    /*

    bindLabelCount = () => {
        return this.state.ItemList.map((item, index) => {
            
            return (<>


                <div class="modal-header sp-delv-header align-items-center">
                    <h5 class="modal-title" id="exampleModalLongTitle">Label Count Confirmation - PO# {item.PO_ID}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"><img
                        src="images/close-icon.svg" alt="close" /></button>
                </div>


                <div class="modal-body p-4">
                    <div class="mb-5">

                        <p class="mb-1 font-18 font-medium">Item Details for the<span class="font-bold"> Receiver # {item.barcodeid} </span> </p>
                        <p class="mb-0 font-16 font-regular d-flex align-items-center"><span class="mr-2 mb-1"><img src="images/info-icon-sdi.svg" alt="Info" class="info-icon-size" />
                        </span>The following items have a receiver quantity count exceeding 10 (>10). </p>
                    </div>
                    <div class="table-responsive wo-custom-scrollable count-table-scroll">
                        <table class="table split-delv-table border-bottom mb-5">
                            <thead class="sticky-top">
                                <tr>
                                    <th>Item Info</th>
                                    <th>CRIB</th>
                                    <th class="pl-5">Bin Location</th>
                                    <th class="text-right pr-5">Receiver Qty</th>
                                    <th class="pl-5">Label Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.bindItems()}
                            </tbody>
                        </table>
                    </div>
                </div>




                <div class="modal-footer border-0">
                    <button class="btn btn-custom-primary font-15 font-medium px-4 py-2" onClick={() => this.printLabels()} data-dismiss="modal">Print</button>
                </div>
            </>

            )
        })
    }
    */

    bindItems = () => {
        // let qtyLessThan10 = this.state.POListItems.filter(item => item.PO_QTY > 10);
        return this.state.listDetail.map((item, index) => {
            
            return (<>
                <tr>
                    <td class="text-nowrap py-3">
                        <p class="font-14 font-medium mb-0">{item.INV_ITEM_ID}</p>
                        <p class="mb-0 label-value-color" style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{item.DESCR254_MIXED}</p></td>
                    <td class="text-black">{item.BUSINESS_UNIT_IN}</td>
                    <td class="pl-5 text-black">{item.Bin_Location}</td>
                    <td class="text-right text-black pr-5">{item.PO_QTY}</td>
                    <td class="pl-5">
                        <input type="number" className="form-control count-width text-black" placeholder="Enter label count" value={item.Entered_Label_Count} min="1" max="99999" oninput="validity.valid||(value='');"
                            onChange={(e) => this.handleChangeLabelCount(index, e)}
                        />

                    </td>
                </tr>
            </>
            )


        })
    }




    POLineGrid = () => {
        return this.state.PODetailList.map((item, index) => {
            
            let ImageUrl = "";
            if (this.state.ImageArray != "" && this.state.ImageArray != null) {
                
                let ImageDet = this.state.ImageArray.filter((value, indexVal) => value.INV_ITEM_ID == item.INV_ITEM_ID);
                ImageUrl = ImageDet[0].ISA_ORIG_URL;
            }
            let imgArr = [{ original: ImageUrl, thumbnail: ImageUrl }]
            return (
                <tr className="p" id={index}>
                    <td colSpan="12" className=" py-0" style={{ "borderBottom": "1px solid #e7e7e9" }}>
                        <div className="accordian-body collapse py-3" id="order-row-1" aria-expanded="true" onChange={() => this.handleAccordion()}>                                                                                                                                                                                                                                   <div className="w-100 float-left pb-3">
                            <div className="col-md-12 Rcv-img">
                                <div className="row align-items-center">
                                    {ImageUrl != "" && ImageUrl != "\N" && ImageUrl != "\\N" ? <div className="col-lg-2 col-md-2">
                                        {/*<img src={ImageUrl} alt="Image" style={{ "width": "130px", "height": "150px" }} />*/}
                                        <ImageGallery items={imgArr} showFullscreenButton={true} showPlayButton={false} showThumbnails={false} disableKeyDown={true} showNav={false}
                                        />
                                    </div> : <div className="col-lg-2 col-md-2">
                                            <img src="/Images/noimage_new.png" alt="No_Image" style={{ "width": "130px", "height": "150px" }} />
                                        </div>}
                                    <div className="col-md-10  mb-1 pl-3">
                                        <div className="row">
                                            <div className="col-md-12 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Item</Trans><span> </span><Trans>Description</Trans><span> :</span></label>
                                                <label className="item-details-value ml-1">{item.DESCR254_MIXED}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Received</Trans> <span>QTY</span></label>
                                                {/* PC_RC_21 CPW_284 S.sanjay */}
                                                <input type="text" className="form-control" maxLength={((item.HQTYPO - item.HQTYLNACCPT).toString().length) + 5} disabled={item.HQTYPO - item.HQTYLNACCPT > 0 ? false : true} value={item.PO_QTY} onChange={(e) => this.handleChangePOQTY(index, e)} />
                                            </div>

                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Tracking</Trans> <span> #</span></label>
                                                <input type="text" className="form-control " maxLength="30" value={item.RECVTRACKNO.trim()} disabled={item.HQTYPO - item.HQTYLNACCPT > 0 ? false : true} onChange={(e) => this.handleChangeTRACKNO(index, e)} />
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Ship Via</Trans></label>
                                                <div className="col-lg-12 col-md-12 float-left p-0 col-12">
                                                    <Select
                                                        disabled={item.HQTYPO - item.HQTYLNACCPT > 0 ? false : true}
                                                        className="DropDown-Font-Size"
                                                        id={"shipvia" + index}
                                                        value={item.RECVSHIPVIA}
                                                        onChange={(e) => this.handleChangeShipVia(index, e)}
                                                        options={this.state.ShipviaList}
                                                    />
                                                </div>

                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label">Ln <span>:</span></label>
                                                <label className="item-details-value ml-1">{item.REQ_LINE_NBR}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label">Sc <span>:</span></label>
                                                <label className="item-details-value ml-1">{item.SCHED_NBR}</label>
                                            </div><div className="col-md-2 pr-0 mb-2">
                                                <label className="catalog-label"><span>SDI</span> <Trans>Item</Trans><span> </span><Trans>ID</Trans><span> :</span></label>
                                                <label className="item-details-value ml-1">{item.INV_ITEM_ID}</label>
                                            </div>

                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Bin</Trans> <Trans>Location</Trans> <span> :</span></label>
                                                <label className="item-details-value ml-1">{item.Bin_Location}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><span><Trans>Manufacturer</Trans></span><span> <Trans>Part #</Trans></span><span> :</span></label>
                                                <label className="item-details-value ml-1">{item.MFG_ITM_ID}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Supplier</Trans> <Trans>Item</Trans><span> </span><Trans>ID</Trans><span> :</span></label>
                                                <label className="item-details-value ml-1">{item.ITM_ID_VNDR}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><span>PO QTY</span> <span>:</span></label>
                                                <label className="item-details-value ml-1">{item.HQTYPO}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Open</Trans> <span>QTY</span> <span>:</span></label>
                                                <label className="item-details-value ml-1">{item.HQTYPO - item.HQTYLNACCPT}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label">UOM <span>:</span></label>
                                                <label className="item-details-value ml-1">{item.UNIT_OF_MEASURE}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Ship Date</Trans> <span>:</span> </label>
                                                <label className="item-details-value ml-1">{item.ISA_ASN_SHIP_DT}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><span>BU</span> <Trans>In</Trans> <span>:</span> </label>
                                                <label className="item-details-value ml-1">{item.BUSINESS_UNIT_IN}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><span>Empl.</span> <Trans>Name</Trans> <span>:</span></label>
                                                <label className="item-details-value ml-1">{item.Emp_Name}</label>
                                            </div>

                                            {/*  <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><span>PO</span> <Trans>Price</Trans></label>
                                                <label className="item-details-value ml-1"> {item.PO_PRICE}</label>
                                            </div>*/}
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Currency</Trans>  <span>:</span> </label>
                                                <label className="item-details-value ml-1">{item.CURRENCY_CD}</label>
                                            </div>

                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Kit Flag</Trans> <span>:</span></label>
                                                <label className="item-details-value ml-1">{item.KIT_FLAG}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Work Order</Trans> <span># :</span></label>
                                                <label className="item-details-value ml-1">{item.ISA_WORK_ORDER_NO}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Machine</Trans><span> # :</span></label>
                                                <label className="item-details-value ml-1">{item.ISA_MACHINE_NO}</label>
                                            </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                <label className="catalog-label"><Trans>Package Qty</Trans><span>:</span></label>
                                                <label className="item-details-value ml-1">{item.CONVERSION_RATE}</label>
                                            </div>




                                            {/* <div className="col-md-4 pr-0 mb-2">
                                                    <label className="catalog-label d-block"> Enter Receiving Notes</label>
                                                    <textarea className="form-control custom-textarea" placeholder=""></textarea>
                                                </div>
                                            <div className="col-md-4 pr-0 mb-2">
                                                    <label className="catalog-label d-block">Enter Order Notes</label>
                                                    <textarea className="form-control custom-textarea" placeholder=""></textarea>
                                                </div> */}

                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>

                        </div>
                    </td>
                </tr>
            )
        })
    }

    render() {
        
        return (
            <div>
                <div className="container-fluid content-section">
                    <div className="row">
                        <div className="col-md-12 page-heading mb-3">
                            <h5 className="page-title"><Trans>Receive Items</Trans></h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-OrdStatus">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                        <div className="col-md-12 border-bottom mb-3">
                            <div className="row align-items-center">
                                <div className="col-md-3 col-lg-2 mb-3">
                                    <label className="w-100 catalog-label" style={{}}><Trans>Ship To</Trans></label>
                                    <div className="w-100">
                                        <Select
                                            className="DropDown-Font-Size"
                                            value={this.state.defaultShipto}
                                            onChange={(e) => this.handleChangeShipto(e)}
                                            options={this.state.ShiptoList}
                                            noOptionsMessage={() => (this.state.isLoading ? "Loading......" : "No options")}
                                        />

                                    </div>
                                </div>
                                <div className="col-md-3 col-lg-2 mb-3">
                                    <label className="catalog-label w-100" style={{}}><Trans>Supplier</Trans> </label>
                                    <div className="w-100">
                                        <Select
                                            className="DropDown-Font-Size"
                                            value={this.state.defaultVendor || null}
                                            onChange={(e) => this.handleChangeVendor(e)}
                                            options={this.state.VendorList}
                                            noOptionsMessage={() => (this.state.isLoading ? "Loading......" : "No options")}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3 col-lg-2 mb-3">
                                    <label className="w-100 catalog-label" style={{}}><span>Select a PO #</span></label>
                                    <div className="w-100">
                                        <Select
                                            className="DropDown-Font-Size"
                                            value={this.state.defaultPO || null}
                                            onChange={(e) => this.handleChangePO(e)}
                                            options={this.state.POList}
                                            noOptionsMessage={() => (this.state.isLoading ? "Loading......" : "No options")}
                                        />
                                    </div>
                                </div>
                                
                                <div className="col-md-1 text-center mb-3">(OR)</div>
                                
                                <div className="col-md-3 col-lg-2 mb-3">
                                    <label className="catalog-label"><span>PO #</span></label>
                                    <input type="text" className="form-control" maxlength="10" placeholder="Enter a PO# manually" value={this.state.POID} onChange={(e) => this.handleChangePOSearch(e)} />

                                    {/*   <div className="col-md-12 px-0 mt-2 float-left">

                                                 <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                                <input type="checkbox" className="custom-control-input" id="customCheck-16a" name="example1" />
                                                            <label className="custom-control-label" htmlFor="customCheck-16a"></label>
                           
                                                        </div>
                                            <label className="catalog-label float-left mt-1 space-check ">Pad with leading zero (s)</label>

                                                    </div>*/}
                                </div>

                                

                                <div className="col-md-5 col-lg-3 mb-3">
                                    <label className="catalog-label w-100"><Trans>Select Duration</Trans></label>
                                    <div className="w-100">
                                        <label className="custom-radiobtn"><span>6 </span> <Trans>Months</Trans>
                                            <input type="radio" name="searchoption" id="duration0" onChange={(e) => this.handleChangeDURATION("0", e)} />
                                            <span className="checkmark checkmark-org"></span>
                                        </label>
                                        <label className="custom-radiobtn"><span>12 </span> <Trans>Months</Trans>

                                            <input type="radio" name="searchoption" id="duration1" onChange={(e) => this.handleChangeDURATION("1", e)} />
                                            <span className="checkmark checkmark-org"></span>
                                        </label>
                                        <label className="custom-radiobtn"><span>2 </span><Trans>Years</Trans>
                                            <input type="radio" name="searchoption" id="duration2" onChange={(e) => this.handleChangeDURATION("2", e)} />
                                            <span className="checkmark checkmark-org"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-12 text-right my-3">
                                    {/*9/21/22, Bug - 2675, To change the cancel button text as clear, Dhevanesam R] */}
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-2" onClick={() => this.cancel()}><Trans>Clear</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn" onClick={() => this.GetPOAction()}><Trans>Apply</Trans><span> </span><Trans>Filter</Trans></button>
                                </div>

                                <div className="col-md-12">
                                    {this.state.pageLoad == true ?

                                        this.state.PODetailList.length > 0 ?
                                            <div className="table-responsive">
                                                <table className="table ZEUS_Grid chk-ordertbl">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className=" position-sort-icon"><span>PO </span><Trans>ID</Trans></th>
                                                            <th className=" position-sort-icon"><span>PO </span><Trans>Date</Trans></th>
                                                            <th className="position-sort-icon"><Trans>Ship To</Trans><span> </span> <Trans>Location</Trans></th>
                                                            <th className=" position-sort-icon"><Trans>Supplier</Trans><span> </span><Trans>ID</Trans></th>
                                                            <th className=" position-sort-icon"><Trans>Supplier</Trans></th>
                                                            <th className=" position-sort-icon"><Trans>Ship To</Trans><span> </span><Trans>Address</Trans></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.POHeaderGrid()}
                                                        {this.POLineGrid()}
                                                    </tbody>
                                                </table>
                                            </div> : (<section className="site-undercontruction container text-center center-panel-1">
                                                <div className="img-section">
                                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                                </div>
                                                <p className="search-result-content pt-4">No Records found
                                            </p>
                                            </section>) : null

                                    }
                                </div>
                                {this.state.PODetailList.length > 0 ? <><div className="col-md-12 text-right mb-5">
                                    <button className="btn btn-primary custom-btn-primary primary-btn" onClick={() => this.SubmitReceive()}><Trans>Submit</Trans></button>
                                </div></> : null}
                            </div>
                        </div>





                        <div className="modal userid" id="successpopup" data-backdrop="static" data-keyboard="false">
                            <div className="modal-dialog  custom-popup modal-dialog-centered justify-content-center">
                                <div className="modal-content" style={{ width: "143%" }}>
                                    {/* Modal Header */}
                                    <div className="modal-header">

                                    </div>
                                    {/* Modal body */}
                                    <div className="modal-body">
                                        <div className="row justify-content-center">
                                            <div className="col-md-12">
                                                <div className="text-center mt-2">
                                                    {this.state.SubmitResponse.toLowerCase().includes("error") ? <img src="Images/close.png" alt="Adjustment Failed" /> : <img src="Images/success-alert.png" alt="Adjustment Success" />}
                                                </div>
                                                <div className="text-center my-4">
                                                    {this.state.SubmitResponse.toLowerCase().includes("error") ? <span className="info-label">{this.state.SubmitResponse}</span> : <span className="info-label">Receiver ID:{this.state.SubmitResponse}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 text-center mb-2">
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" onClick={() => this.checkAndPrint()} data-dismiss="modal">OK </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/**************END***************/}

                    </div>

                    <div className="modal userid" id="failpopup" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog  custom-popup modal-dialog-centered justify-content-center">
                            <div className="modal-content" style={{ width: "143%" }}>
                                {/* Modal Header */}
                                <div className="modal-header">

                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12">
                                            <div className="text-center mt-2">
                                                <p>Error in Printing Labels</p>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" onClick={() => this.deliveryTicket()} data-dismiss="modal">OK </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="modal userid" id="successprint" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog  custom-popup modal-dialog-centered justify-content-center">
                            <div className="modal-content" style={{ width: "143%" }}>
                                {/* Modal Header */}
                                <div className="modal-header">

                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12">
                                            <div className="text-center mt-2">
                                                <p>Successfully Printed</p>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" onClick={() => this.deliveryTicket()} data-dismiss="modal">OK </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                    <div className="modal userid" id="technicalIssue" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog  custom-popup modal-dialog-centered justify-content-center">
                            <div className="modal-content" style={{ width: "143%" }}>
                                {/* Modal Header */}
                                <div className="modal-header">

                                </div>
                                {/* Modal body */}
                                <div className="modal-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12">
                                            <div className="text-center mt-2">
                                                <p>Technical Issue, Please Contact SDI</p>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" onClick={() => this.deliveryTicket()} data-dismiss="modal">OK </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                    <div className="modal orderstatus-popup" id="pdfPreview" data-backdrop="static" data-keyboard="false">
                        <PDFPreviewComponent key={1} base64URL={this.state.base64URL} PdfPage="2" pdfTitle="Delivery Ticket Report" {...this.props} />


                    </div>



                    {/*   <div className="col-md-12">

                                                    <span className="total-records mt-2 d-inline-block">
                                                        Number of Records:<span className="ml-2">6</span>
                                                    </span>
                                                    <ul className="custom-pagination pagination float-right">
                                                       <li className="page-item disabled">
                                                            <a className="page-link" href="#" tabIndex="-1"><span className="right-pagination-arrow"></span></a>
                                                        </li>
                                                        <li className="page-item"><a className="page-link" href="#">01</a></li>
                                                        <li className="page-item active">
                                                            <a className="page-link" href="#">02</a>
                                                        </li>
                                                        <li className="page-item"><a className="page-link" href="#">03</a></li>
                                                        <li className="page-item"><a className="page-link" href="#">...</a></li>
                                                        <li className="page-item"><a className="page-link" href="#">20</a></li>
                                                        <li className="page-item">
                                                            <a className="page-link" href="#"><span className="left-pagination-arrow"></span></a>
                                                        </li>
                                                    </ul>
                </div> */
                    }
                    <div className="modal fade wo-details pl-0 show" tabIndex={-1} role="dialog" id="labelcount" aria-modal="true" style={{ display: 'block' }} data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog modal-lg count-confirm-popup-width" role="document">
                            <div className="modal-content border-0">
                                <div className="modal-header sp-delv-header align-items-center">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Label Count Confirmation - PO # {this.state.PO_num}  </h5>
                                </div>
                                <div className="modal-body p-4">
                                    <div className="mb-5">
                                        <p className="mb-1 font-18 font-medium">Item Details for the<span className="font-bold"> Receiver # {this.state.SubmitResponse}</span> </p>
                                        { /*06/06/24,CPW-284,PC_RC_19], Sanjay S */}
                                        {/* <p className="mb-0 font-16 font-regular d-flex align-items-center"><span className="mr-2 mb-1"><img src="images/info-icon-sdi.svg" alt="Info" className="info-icon-size" /></span>The following items have a receiver quantity count exceeding 10 (&gt;10). </p>*/}
                                    </div>
                                    {/*-table starts here*/}
                                    <div className="table-responsive wo-custom-scrollable count-table-scroll">
                                        <table className="table split-delv-table border-bottom mb-5">
                                            <thead className="sticky-top">
                                                <tr>
                                                    <th>Item Info</th>
                                                    <th>CRIB</th>
                                                    <th className="pl-5">Bin Location</th>
                                                    <th className="text-right pr-5">Receiver Qty</th>
                                                    <th className="pl-5">Label Count</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.bindItems()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/*-table ends here*/}
                                </div>
                                <div className="modal-footer border-0">

                                    <button className="btn btn-custom-primary font-15 font-medium px-4 py-2" onClick={() => this.printLabels()}>Print</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="modal fade expedite-panel-po-work-container replenishment-page"
                        id="packingSlipQtyPopup"
                        tabIndex={-1}
                        role="dialog"
                        aria-labelledby="exampleModalCenterTitle"
                        aria-hidden="true"
                    >
                        <div
                            className="modal-dialog modal-md custom-popup modal-dialog-centered"
                            role="document"
                        >
                            <div className="modal-content custom-container border-0">
                                <div className="modal-header align-items-center">
                                    <h4 className="font-18 mt-1 fSoftware-Inventory-servicenowont-18 font-medium">
                                        Confirm packing slip quantity
                                    </h4>
                                    <button type="button" className="btn py-0" data-dismiss="modal">
                                        <img src="images/close-icon-popup.svg " alt="close-icon" />
                                    </button>
                                </div>
                                {this.state.packQtyData && this.state.packQtyData.length > 0  ?
                                    <div className="modal-body terms-scroll pt-1 pb-4 px-4 popup-info-container">
                                        <div className="row">
                                            <div className="col-lg-12 justify-content-end mt-3">
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td className="py-2 text-black font-14 font-medium">
                                                                PO Line #
                                                            </td>
                                                            <td className="py-2">:</td>
                                                            <td className="py-2 font-14 pl-3">{this.state.packQtyData[this.state.packQtyIndex].REQ_LINE_NBR}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="py-2 text-black font-14 font-medium">
                                                                Inventory Part #
                                                            </td>
                                                            <td className="py-2">:</td>
                                                            <td className="py-2 font-14 pl-3">{this.state.packQtyData[this.state.packQtyIndex].ITM_ID_VNDR}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="py-2 text-black font-14 font-medium">
                                                                Outstanding Qty
                                                            </td>
                                                            <td className="py-2">:</td>
                                                            <td className="py-2 font-14 pl-3">{this.state.packQtyData[this.state.packQtyIndex].HQTYPO - this.state.packQtyData[this.state.packQtyIndex].HQTYLNACCPT}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="py-2 text-black font-14 font-medium">
                                                                Receiving Qty
                                                            </td>
                                                            <td className="py-2">:</td>
                                                            <td className="py-2 font-14 pl-3">{this.state.packQtyData[this.state.packQtyIndex].PO_QTY}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="py-2 text-black font-14 font-medium pr-3">
                                                                Packing Slip Qty
                                                            </td>
                                                            <td className="py-2">:</td>
                                                            <td className="py-2 font-14 pl-3">
                                                                <input
                                                                    className="form-control packing-slip-count"
                                                                    type="text"
                                                                    value={this.state.packQtyData[this.state.packQtyIndex].PACK_SLIP_QTY}
                                                                    onChange={(e) => this.onChangePackingSlipQty(e)}
                                                                    maxLength={5}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="d-flex justify-content-between mt-3 align-items-center">
                                                    <div>
                                                        <p className="m-0 packing-quantity-pagination">
                                                            <span className="font-bold pr-1">{this.state.packQtyIndex + 1}</span>/
                                                            <span className="pl-1">{this.state.packQtyData.length}</span>
                                                        </p>
                                                    </div>
                                                    <div>
                                                        {this.state.packQtyIndex > 0 ?
                                                            <button className="btn custom-btn-secondary secondary-btn px-4 mr-3" onClick={() => this.setState({ packQtyIndex: this.state.packQtyIndex - 1 })}>
                                                                Back
                                                            </button> : null}
                                                        {this.state.packQtyIndex + 1 == this.state.packQtyData.length ?
                                                            <button className="btn custom-btn-primary px-4 m-0 font-medium" onClick={() => this.submitPackingSlip()} disabled={!this.state.packQtyData[this.state.packQtyIndex].PACK_SLIP_QTY || parseInt(this.state.packQtyData[this.state.packQtyIndex].PACK_SLIP_QTY) == 0}>
                                                                Submit
                                                            </button> : <button className="btn custom-btn-primary px-4 m-0 font-medium" onClick={() => this.setState({ packQtyIndex: this.state.packQtyIndex + 1 })} disabled={!this.state.packQtyData[this.state.packQtyIndex].PACK_SLIP_QTY || parseInt(this.state.packQtyData[this.state.packQtyIndex].PACK_SLIP_QTY) == 0}>
                                                                Next
                                                            </button>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>








        )

    }
}



export default withTranslation()(MMReceivingOrderComponent);